export class KeyFigureModel {
    constructor(
        public iconeKey: string,
        public valueKey: number,
        public textSing: string,
        public textPlural: string,
        public valueKeyInactive?: number
    ) {}
}
